import { render, staticRenderFns } from "./MCBindMedicneCabinetDialog.vue?vue&type=template&id=48908bf3&scoped=true&lang=pug&"
import script from "./MCBindMedicneCabinetDialog.vue?vue&type=script&lang=ts&"
export * from "./MCBindMedicneCabinetDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MCBindMedicneCabinetDialog.vue?vue&type=style&index=0&id=48908bf3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48908bf3",
  null
  
)

export default component.exports